module.exports = __webpack_public_path__ + "static/media/anuncio3.0a655ed3.png";